module.exports = __webpack_public_path__ + "static/media/technology-support.f306d986.svg";